import { NgModule } from '@angular/core';

import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { SharedModule } from '../../../../shared';
import { ClienteCadastroModule } from '../cadastro';
import { ClienteCentralCompraSelectParticipanteModalModule } from '../central-compra/select-participante-modal';
import { ClienteFilterModalModule } from '../filter/modal';
import { ClienteFormTextModule } from '../form-text';
import { CardMessageCartaIsencaoIpiVencidaModule } from '../ipi/card-message-carta-isencao-ipi-vencida';
import { CardMessageDestaqueIpiModule } from '../ipi/card-message-destaque-ipi';
import { ClientePipeSharedModule } from '../pipes';
import { ClienteSituacaoModule } from '../situacao';

import { TypeaheadClientePessoaComponent } from './typeahead-cliente-pessoa.component';
import { TypeaheadClienteComponent } from './typeahead-cliente.component';

@NgModule({
    imports: [
        SharedModule,
        ClientePipeSharedModule,
        ClienteCadastroModule,
        ClienteSituacaoModule,
        ClienteFormTextModule,
        ClienteFilterModalModule,
        ClienteCentralCompraSelectParticipanteModalModule,
        CardMessageCartaIsencaoIpiVencidaModule,
        CardMessageDestaqueIpiModule,
        TypeaheadModule.forRoot()
    ],
    declarations: [
        TypeaheadClienteComponent,
        TypeaheadClientePessoaComponent
    ],
    exports: [
        SharedModule,

        TypeaheadClienteComponent,
        TypeaheadClientePessoaComponent
    ]
})
export class ClienteTypeaheadSharedModule { }
